module.exports = __webpack_public_path__ + "static/media/left.08543f36.png";